module.exports = function getResource(label, vars = []) {
    const resources = {
        title: 'Auto-Replenish Resumed',
        mainHeader: 'You’re all set',
        subHeader: 'Your Auto-Replenish has resumed and will start shipments on ',
        item: 'ITEM',
        qty: 'Qty',
        notRated: 'Not rated',
        oneReview: '1 review',
        yearlySavings: 'yearly savings',
        done: 'Done'
    };

    return resources[label];
};
